import { COLLECTIONS } from "constants/action-types";
import { IPendingMutation } from "lib/dexie-db-service/schemas";

interface IPendingMutations {
    mutations: object[];
    objectNamespace: string;
    objectId: string;
    documentId: string;
    revisionId: number;
}

export interface ICollectionRequestSavePendingMutationAction {
    type: string;
    payload: IPendingMutations;
}
export const collectionRequestSavePendingMutation = (
    params: IPendingMutations
): ICollectionRequestSavePendingMutationAction => {
    const { objectNamespace, objectId, documentId, revisionId, mutations } = params;
    return {
        type: COLLECTIONS.COLLECTION.PENDING_MUTATION.REQUEST_SAVE,
        payload: {
            documentId,
            mutations,
            objectNamespace,
            objectId,
            revisionId,
        },
    };
};

export interface ICollectionSetPendingMutationAction {
    type: string;
    payload: {
        objectId: string;
        pendingMutation: IPendingMutation | null;
    };
}
export const collectionSetPendingMutation = (
    objectId: string,
    pendingMutation: IPendingMutation | null
): ICollectionSetPendingMutationAction => {
    return {
        type: COLLECTIONS.COLLECTION.PENDING_MUTATION.SET,
        payload: {
            objectId,
            pendingMutation,
        },
    };
};

export interface ICollectionRequestDeletePendingMutationAction {
    type: string;
    payload: {
        documentId;
        objectNamespace: string;
        objectId: string;
    };
}
export const collectionRequestDeletePendingMutation = (
    documentId: string,
    objectNamespace: string,
    objectId: string
): ICollectionRequestDeletePendingMutationAction => {
    return {
        type: COLLECTIONS.COLLECTION.PENDING_MUTATION.REQUEST_DELETE,
        payload: {
            documentId,
            objectNamespace,
            objectId,
        },
    };
};

export interface ICollectionApplyPendingMutationAction {
    type: string;
    payload: {
        pendingMutation: IPendingMutation;
        syncImmediately: boolean;
    };
}
export const collectionApplyPendingMutation = (
    pendingMutation: IPendingMutation,
    syncImmediately: boolean = false
): ICollectionApplyPendingMutationAction => {
    return {
        type: COLLECTIONS.COLLECTION.PENDING_MUTATION.APPLY,
        payload: {
            pendingMutation,
            syncImmediately,
        },
    };
};
